module.exports = __webpack_public_path__ + "media/landing_page/apple-icon-kale-8b3ad415.svg";